/* global document, console */

// POLYFILL
// test = boolean indicating support for feature represented by the polyfill url
// url = url of polyfill script
// callback to run when script is loaded
export default function(test, url, callback) {
  if (test === true) {
    callback();
  } else {
    const script = document.createElement('script');
    script.src = url;
    script.onreadystatechange = callback;
    script.onload = callback;
    script.onerror = () => {
      // eslint-disable-next-line  no-console
      return console.error('no polyfill found!');
    };
    document.querySelector('head').appendChild(script);
  }
}
